import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationAlert } from "@/molecules/InformationAlert"
import { LanguageIconCell } from "@/molecules/LanguageIconCell"
import { TableCard } from "@/organisms/Drawers/components/TriageDrawer/components/KaiFix/components/TableCard"
import { TipList } from "@/pages/TriagePage/components/molecules/TipList"
import { Description } from "@/pages/TriagePage/components/pages/AdrPage/components/Description"
import { AdrTabTemplate } from "@/pages/TriagePage/components/templates/AdrTabTemplate"
import { CveCard } from "./CveCard"

import styles from "./VulnerableFunctionsTabAdr.module.scss"

import type { CVEIncident } from "@/domain/adr"

export const VulnerableFunctionsTabAdr = (props: { incident: CVEIncident }) => {
  const { incident } = props
  const { type, what } = incident
  const { t } = useTranslation("translation", {
    keyPrefix: `triage.adr.incidents.${type}.vulnerable_fn`
  })
  const { t: tAll } = useTranslation()
  const { vulnerabilities, vulnerabilitiesMeta } = what

  const group = vulnerabilities.reduce(
    (acc, val) => {
      if (!acc[val.packageVersions]) acc[val.packageVersions] = []

      acc[val.packageVersions].push(val)

      return acc
    },
    {} as Record<string, CVEIncident["what"]["vulnerabilities"]>
  )
  const packages = Object.keys(group)
  const cveLength = vulnerabilities.length
  const packagesLength = packages.length

  return (
    <AdrTabTemplate>
      <Description title="Vulnerable Functions" gap={0}>
        <Flex vertical gap={16}>
          <Text type="secondary" className="sm-text-ks">
            {t("description", {
              count: cveLength,
              cve: tAll("general.cve", { count: cveLength }),
              packages: `${packagesLength} ${tAll("general.package", { count: packagesLength })}`
            })}
          </Text>
          <Flex vertical gap={24}>
            {vulnerabilitiesMeta.packages.list.map(({ name, language }) => (
              <TableCard
                key={name}
                columns={[
                  {
                    title: (
                      <Flex justify="space-between">
                        {LanguageIconCell(name, { language })}
                        <Text type="secondary" className="sm-text-ks">
                          {`${group[name].length} ${tAll("general.issue", { count: group[name].length })}`}
                        </Text>
                      </Flex>
                    ),
                    render: CveCard
                  }
                ]}
                dataSource={group[name]}
              />
            ))}
          </Flex>
        </Flex>
      </Description>

      <Description title="Investigation Tips" gap={12}>
        <InformationAlert
          message={t("tips.info")}
          className={styles.infoAlert}
        />
        <TipList>{t("tips.1")}</TipList>
      </Description>
    </AdrTabTemplate>
  )
}
